<script lang="ts">
	import { onMount } from "svelte";

	import PromptCard from "./PromptCard.svelte";

	import { deviceCheck } from "$lib/helpers/user";

	let deviceType: string;
	let hasScrolledFold = false;
	let pageIsPricing = false;

	const markAsAccepted = () => localStorage.setItem("promptAccepted", "true");
	const accepted = () => localStorage.getItem("promptAccepted");

	const markAsRejected = () => localStorage.setItem("promptRejected", "true");
	const rejected = () => localStorage.getItem("promptRejected");

	onMount(() => {
		pageIsPricing = window.location.pathname.includes("pricing") || window.location.pathname == "/";

		document.addEventListener("scroll", () => {
			if (window.scrollY > 1000) {
				hasScrolledFold = true;
			}
		});

		window.addEventListener("beforeinstallprompt", (e) => {
			e.preventDefault();
			const prompt = e as any;

			prompt.prompt();
			prompt.userChoice.then((choiceResult: any) => {
				if (choiceResult.outcome === "accepted") {
					markAsAccepted();
				} else {
					markAsRejected();
				}
			});
		});
	});

	$: pageIsPricing;
</script>

{#key hasScrolledFold}
	{#if deviceCheck()?.valid && hasScrolledFold && !pageIsPricing && (!accepted() || !rejected())}
		<PromptCard {deviceType} />
	{/if}
{/key}
